import { DataProvider } from "react-admin";
import { appConfig } from "@/commons";
import { Voucher } from "@/types";
import { httpClient } from "@/utilities";

const apiUrl = appConfig.api.baseUrl;

export type ClaimProvider = Partial<DataProvider> & {
  claimVoucher: (args: { code: string }) => Promise<{ data: Voucher }>;
};

const claimProvider: ClaimProvider = {
  async claimVoucher({ code }) {
    const { json } = await httpClient(`${apiUrl}/vouchers/claim`, {
      method: "POST",
      headers: new Headers({ "Content-Type": "application/json" }),
      body: JSON.stringify({ code }),
    });

    const payload = json?.voucher ?? json;
    if (!payload) throw new Error("Invalid API response: No data");

    return {
      data: { id: payload.id ?? payload.code ?? "claim", ...payload },
    };
  },
};

export default claimProvider;
